/**
 * @file todoFollowUp.ts
 * @brief Client twin of BACKEND boardroom/todoFollowUp.mjs (05-10-2026).
 *
 * @details
 * A to-do for someone outside the company is chased by a company member, the
 * meeting owner by default. "External" is decided against the company roster
 * (useAssignablePeople), exactly as the server decides it before pushing to
 * Asana, so the row only offers a follow-up owner when Asana will use one.
 */

import type { MeetingTodo } from "./schemas";

const norm = (v: unknown) => String(v ?? "").trim().toLowerCase();

export function isExternalAssignee(todo: MeetingTodo, rosterEmails: Set<string>): boolean {
  if (todo.assigneeSpeakerId === "team") return false;
  if (todo.assigneeUserId) return false;
  const email = norm(todo.assigneeEmail);
  const name = String(todo.assigneeName ?? "").trim();
  if (!email && !name) return false;
  if (email && rosterEmails.has(email)) return false;
  return true;
}
